import * as React from 'react';
import { Set, Map } from 'immutable';
import memoizeOne from 'memoize-one';

import elements from 'components/elements';

import Box from '@mui/material/Box';
import { RowCheckbox, RowCheckboxWrapper } from 'components/Tables/grid/withSelectedRows/StyledComponents';

import cx from 'classnames';

const withSelectedRows = (WrappedComponent) => {
  class WithSelectedRows extends React.Component {
    memoIsSelectedRow = memoizeOne(this.isSelectableRow);

    onChangeSelectedRows = (row) => (e) => {
      const { selectedRows, onChangeSelectedRows } = this.props;
      const newSelectedRows = e.currentTarget.checked ? selectedRows.add(row) : selectedRows.delete(row);
      onChangeSelectedRows(newSelectedRows);
    };

    get isOpenedCheckbox() {
      const { selectedRows } = this.props;
      return selectedRows.size;
    }

    getItem = (row, col) => {
      const { getItem, selectedRows, disableCheckboxes } = this.props;
      if (!this.isSelectableCol(row, col)) return getItem(row, col);

      return (
        <Box display="flex" alignItems="center" height="100%">
          <RowCheckboxWrapper className={cx({ 'is-visible': this.isOpenedCheckbox })}>
            <RowCheckbox
              size="small"
              checked={selectedRows.has(row)}
              onChange={this.onChangeSelectedRows(row)}
              disabled={disableCheckboxes}
              data-element={elements.je.grid.selectOne}
            />
          </RowCheckboxWrapper>
          <Box flex="0 1 100%" position="relative" maxWidth="100%">
            {getItem(row, col)}
          </Box>
        </Box>
      );
    };

    isSelectableRow(row) {
      const { startRow, countAllRows, lineItems, reconcileColumn, data } = this.props;
      if (lineItems && !lineItems.has(row)) return false;
      if (row <= startRow || row > startRow + countAllRows) return false;
      if (typeof reconcileColumn === 'string') {
        const status = data.getIn([reconcileColumn + row, 'cellSet', 'value']);

        if (status === 'Ignored') return false;
        if (status === 'NoBankAccount') return false;
        if (status === 'Reconciled') return false;
      }
      return true;
    }

    isSelectableCol(row, col) {
      const { selectPlaceCol } = this.props;
      if (this.memoIsSelectedRow(row) && col === selectPlaceCol) return true;
      return false;
    }

    render() {
      const { getItem: propGetItem, isReadOnly } = this.props;
      const getItem = isReadOnly ? propGetItem : this.getItem;

      return <WrappedComponent {...this.props} getItem={getItem} />;
    }
  }

  WithSelectedRows.defaultProps = {
    disableCheckboxes: false,
  };

  return WithSelectedRows;
};

export default withSelectedRows;
